import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToastTypes } from './toast.service';

/**
 * Message types for the MessageBus (aligned with Proximity's MessageTypeEnum)
 */
export enum MessageTypeEnum {
  Noop = 'noop',
  Login = 'login',
  Logout = 'logout',
  Notification = 'notification',
  EntityIssuesChanged = 'entityIssuesChanged',
}

/**
 * New interface aligned with Proximity
 */
export interface IMessage {
  from?: string;
  id: MessageTypeEnum;
  message?: string;
  type?: ToastTypes;  // Keep for backward compatibility with toast.service
}

/**
 * @deprecated Use IMessage instead - kept for backward compatibility
 */
export interface IMessageLegacy {
  from?: string;
  message: string;
  type?: ToastTypes;
}

/**
 * Simple message bus using an observable (aligned with Proximity's MessageBusService)
 */
@Injectable({providedIn: 'root'})
export class MessageBusService {
  private messageSubject = new BehaviorSubject<IMessage>({ id: MessageTypeEnum.Noop });

  public notify(message: IMessage) {
    this.messageSubject.next(message);
  }

  public get messages() {
    return this.messageSubject.asObservable();
  }
}

/**
 * @deprecated Use MessageBusService instead - kept for backward compatibility
 */
@Injectable({providedIn: 'root'})
export class MessageBus {
  constructor(private messageBusService: MessageBusService) {}

  public notify(message: IMessageLegacy) {
    // Convert legacy message to new format
    const newMessage: IMessage = {
      from: message.from,
      id: this.stringToEnum(message.message),
      message: message.message,
      type: message.type,
    };
    this.messageBusService.notify(newMessage);
  }

  public get messages() {
    return this.messageBusService.messages;
  }

  private stringToEnum(message: string): MessageTypeEnum {
    switch (message) {
      case 'login': return MessageTypeEnum.Login;
      case 'logout': return MessageTypeEnum.Logout;
      case 'notification': return MessageTypeEnum.Notification;
      case 'entityIssuesChanged': return MessageTypeEnum.EntityIssuesChanged;
      default: return MessageTypeEnum.Noop;
    }
  }
}
